import { createSelector } from '@ngrx/store'

export const getBusinessCategoriesState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('list'),
)

export const getCreateBusinessCategoryState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('createBusinessCategory'),
)

export const getUpdateBusinessCategoryState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('updateBusinessCategory'),
)

export const getUpdateBusinessSubcategoryState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('updateBusinessSubcategory'),
)

export const getBusinessSubcategoriesState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('subcategories'),
)

export const getCreateBusinessSubcategoryState = createSelector(
  (state: any) => state.businessCategories,
  (state: any) => state.get('createBusinessSubcategory'),
)
